import type { FunctionComponent } from 'react'
import React from 'react'
import * as playerActions from 'context/player/reducer/player.actions'
import {
  ContainerOnlySmallScreens,
  ContainerOnlyBigScreens
} from 'styles/common/Common.styles'

import {
  BookName,
  BookThumb,
  ChapterIndicator,
  ChapterName,
  Container,
  CoverContainer,
  TitleContainer
} from './ContentInfo.styles'
import { usePlayerContext } from 'context/player'
import { useTranslation } from 'i18n'

const ContentInfo: FunctionComponent = () => {
  const {
    dispatch,
    state: { name, imageUrlThumb, currentChapter, audioBooks, isMinimized }
  } = usePlayerContext()
  const { t } = useTranslation()

  return (
    <Container
      onClick={() => {
        if (isMinimized) {
          dispatch(playerActions.maximize())
        }
      }}
      isClickable={isMinimized}
    >
      <CoverContainer data-testid="player-content-info">
        <BookThumb src={imageUrlThumb} alt={`Capa de ${name}`} />
        <div className="hidden w-full max-md:flex max-md:justify-center">
          <BookName>{name}</BookName>
        </div>
      </CoverContainer>
      <TitleContainer>
        <ContainerOnlySmallScreens>
          <ChapterIndicator>
            {t('Capítulo {{current}} de {{total}}', {
              current:
                audioBooks.findIndex(ab => ab.id === currentChapter.id) + 1,
              total: audioBooks.length
            })}
          </ChapterIndicator>
        </ContainerOnlySmallScreens>
        <ChapterName aria-live="polite">
          {
            audioBooks.find(audioBook => audioBook.id === currentChapter.id)
              .title
          }
        </ChapterName>
        <ContainerOnlyBigScreens>
          <BookName>{name}</BookName>
        </ContainerOnlyBigScreens>
      </TitleContainer>
    </Container>
  )
}

export default ContentInfo
